import React from 'react';

const ServicesIntro = () => {
    return (
        <section>
            <div className="infocolors-parallax-media stg-bottom-gap-l" data-appear="fade-up" data-unload="fade-up">
                <img className="infocolors-lazy" src="img/null.png" data-src="img/inner-pages/services.jpg" alt="infocolors Services" width="1920" height="960" />
            </div>

            <div className="stg-row stg-bottom-gap">
                <div className="stg-col-6" data-unload="fade-left">
                    <h2 className="stg-bottom-gap" data-split-appear="fade-up">Get a Creative ✨ Edge Over Your Peers with Infocolors.</h2>
                </div>
                <div className="stg-col-6"></div>
            </div>

            <div className="stg-row stg-tp-column-reverse">
                <div className="stg-col-6 stg-valign-bottom" data-unload="fade-left">
                    <div className="align-right">
                        <a href="/contact" className="infocolors-icon-link" data-appear="fade-right">
                            <div className="infocolors-icon-link-content">
                                <h6>
                                    Unleash your
                                    <br />
                                    creative potential
                                </h6>
                                <span className="infocolors-label">Contact Us</span>
                            </div>
                            <div className="infocolors-icon-wrap">
                                <i className="infocolors-icon infocolors-icon-explore"></i>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="stg-col-6 stg-tp-col-9 stg-tp-bottom-gap" data-appear="fade-left" data-unload="fade-right">
                    <p className="infocolors-large-text">A creative journey starts with the mind that imagines and moves along to the hands that craft, whether it is a spark of an idea, our a fully formed goal, Infocolors has designed its services to bring to help you manifest it.</p>
                </div>
            </div>
        </section>
    );
};

export default ServicesIntro;
